// extracted by mini-css-extract-plugin
module.exports = {"root":"NamedBackLink_root__wftdy","icon":"NamedBackLink_icon__2VDdO"};